<template>
    <SmartLinkItemComponent :id="model.system.id" :component="!model.system.workflow">
        <SmartLinkStandaloneElement :codename="typ.elements.link_text.codename">
            <div class="claim-status">
                <div class="input-group">
                    <input type="text" class="form-control form-control-lg" :placeholder="data.placeholderText" v-model="claim"
                        :aria-label="data.placeholderText" aria-describedby="button-submit">
                    <NuxtLink class="btn btn-primary" id="button-submit" :to="data.statusPageUrl">{{ data.linkText }}</NuxtLink>
                </div>
            </div>
        </SmartLinkStandaloneElement>
    </SmartLinkItemComponent>
</template>

<script setup lang="ts">
import type { ClaimStatusModel } from '~/models';
import { contentTypes } from '~/models';
const typ = contentTypes.claim_status;

const props = defineProps<{ model: ClaimStatusModel }>();
const data = {
    linkText: props?.model?.elements?.linkText?.value,
    placeholderText: props?.model?.elements?.placeholderText?.value,
    statusPageUrl: props?.model?.elements?.statusPageUrl?.value,
}

const claim = ref('');

function submit(){
    
}
</script>
